module.exports = __webpack_public_path__ + "img/banner_search.cf4182fc.png";